<template>
  <div :class="[b(), { 'is-collapse': collapse }]">
    <LeftMenuComponent
      v-for="menu of menus"
      :key="menu.name"
      :item="menu"
      v-on="$listeners"
    >
      <template
        v-for="key of itemSlots"
        #[key]="{ item }"
      >
        <slot
          :name="key"
          :item="item"
        />
      </template>
    </LeftMenuComponent>
  </div>
</template>
<script>
import LeftMenuComponent from './LeftMenuComponent';
import theme from '@zk/theme/lib/variables.scss';
import { isNil } from 'lodash';
import { isOverseasVersion } from 'common-module/src/util';

export default {
  name: 'LeftMenu',
  bemNS: theme.bemNS,
  components: { LeftMenuComponent },
  provide() {
    return {
      menu: this
    };
  },
  props: {
    defaultOpened: {
      type: Array,
      default: () => []
    },
    collapse: {
      type: Boolean,
      default: false
    },
    menus: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      opened: [...this.defaultOpened],
      isOverseasVersion: isOverseasVersion
    };
  },
  computed: {
    itemSlots() {
      return ['prefix', 'icon', 'title', 'suffix'];
    }
  },
  watch: {
    defaultOpened(value) {
      this.opened = value;
    }
  },
  methods: {
    updateDefaultOpened() {
      this.$emit('update:defaultOpened', this.opened);
    },
    toggleOpened(item, value) {
      const index = this.opened.indexOf(item.name);
      const isOpened = index >= 0;
      value = isNil(value) ? !isOpened : value;
      if (value) {
        if (isOpened) {
          return;
        }
        this.opened.push(item.name);
        this.updateDefaultOpened();
        this.$emit('open', item, [...this.opened]);
        return;
      }
      if (isOpened) {
        this.opened.splice(index, 1);
        this.updateDefaultOpened();
        this.$emit('close', item, [...this.opened]);
      }
    },
    // 海外版 点击项目Item
    toProjectList(item, value) {
      const index = this.opened.indexOf(item.name);
      const isOpened = index >= 0;
      value = isNil(value) ? !isOpened : value;
      // this.opened.push(item.name);
      // this.updateDefaultOpened();
      if (value) {
        if (isOpened) {
          return;
        }
        // this.opened.push(item.name);
        // this.updateDefaultOpened();
        this.$router.push('/project/list');
        // this.$emit('open', item, [...this.opened]);
        return;
      }
      if (isOpened) {
        // this.opened.splice(index, 1);
        this.updateDefaultOpened();
        this.$router.push('/project/list');
        // this.$emit('close', item, [...this.opened]);
      }
    }
  }
};
</script>

<style lang="scss">
@include b(left-menu) {
  @include when(collapse) {
    .zk-left-menu-item {
      padding: 0;
    }
    .zk-left-submenu > div .zk-left-menu-item .zk-left-menu-item__content {
      padding: 0 11px;
    }
    .zk-left-menu-item__title, .iconxiala_xinjian, .zk-left-menu-item__prefix, .iconxiangyouzhankai {
      display: none;
    }
    .zk-left-menu-item__content {
      margin: 0 9px;
      padding: 0 11px;
      justify-content: center;
    }
    .zk-left-menu-item__icon, .zk-left-menu__p-icon {
      margin: 0;
    }
  }
}
</style>
